import {
  colorAccessor,
  heightAccessor,
  isDefinedAccessor,
  widthAccessor,
  xAccessor,
  yAccessor,
} from './rect-accessors.js';
import { BarCanvas } from '../../../core/components/canvas/components/BarCanvas.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { DEFAULT_FILL_OPACITY } from '../../../core/constants.js';
import type { AxisIdToScales } from '../../context/XYChartScales.context.js';
import { useRectData } from '../../hooks/useRectData.js';
import { useXYChartColorScales } from '../../hooks/useXYChartColorScales.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { getCurrentScale } from '../../utils/get-scale.js';

export function RectDisplay(props: { axisIdToScales: AxisIdToScales }) {
  const { axisIdToScales } = props;
  const { height, width } = useGridPlotSize();
  const colorScalesMap = useXYChartColorScales();
  const { seriesWithDatapoints } = useRectData();
  const { datapointMetadataMap } = useXYChartData();

  return seriesWithDatapoints.map((series) => {
    const xScale = getCurrentScale(axisIdToScales, series.xAxisId);
    const yScale = getCurrentScale(axisIdToScales, series.yAxisId);
    const colorScale = colorScalesMap.get(series.id);

    return colorScale ? (
      <BarCanvas
        key={series.id}
        data={series.data}
        canvasHeight={height}
        canvasWidth={width}
        color={colorAccessor(colorScale)}
        x={xAccessor(xScale)}
        width={widthAccessor(xScale)}
        y={yAccessor(yScale)}
        height={heightAccessor(yScale)}
        opacity={() => DEFAULT_FILL_OPACITY}
        strokeWidth={1}
        defined={isDefinedAccessor(datapointMetadataMap)}
      />
    ) : null;
  });
}

RectDisplay['displayName'] = 'RectDisplay';
